import {useState} from "react";
import ReportLogsService from "../services/api/report-logs";
import {useSnackbar} from "notistack";
import * as XLSX from "xlsx";
import {saveAs} from "file-saver";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';

const useReportLogs = () => {

    const {enqueueSnackbar} = useSnackbar();

    const [isFetchingReportLogs, setFetchingReportLogs] = useState(false);
    const [reportLogsList, setReportLogsList] = useState([]);
    const [reportLogsListByGeneratedBy, setReportLogsListByGeneratedBy] = useState([]);
    const [isSearchingGeneratedBy, setSearchingGeneratedBy] = useState(false);
    const [isFetchingLogDetails, setFetchingLogDetails] = useState(true);
    const [reportLogsData, setReportLogsData] = useState([]);
    const [isFilterByStatus, setFilterByStatus] = useState(false);
    const [reportLogsListByStatus, setReportLogsListByStatus] = useState([]);
    const [isDownloadingReport, setDownloadingReport] = useState(false);

    const listReportLogs = (startDate, endDate, report_type) => {
        setFetchingReportLogs(true);
        setSearchingGeneratedBy(false);
        setFilterByStatus(false);
        setReportLogsListByStatus([]);
        setReportLogsListByGeneratedBy([]);

        ReportLogsService.listReportLogs(startDate, endDate, report_type).then((res) => {
            console.log("listReportLogs data xxxx", res.data);
            
            if (res.data.success) {
                setReportLogsList(res.data.data); 
                setFetchingReportLogs(false);   
            }

        }).catch((error) => {
            console.log("listReportLogs error xxxx", error);

            setFetchingReportLogs(false);
        })
    }

    const listReportLogsByGeneratedBy = (startDate, endDate, report_type, generated_by) => {
        setFetchingReportLogs(true);
        setFilterByStatus(false); 
        setReportLogsList([]); 
        setReportLogsListByStatus([]);

        ReportLogsService.listReportLogsByGeneratedBy(startDate, endDate, report_type, generated_by).then((res) => {
            console.log("listReportLogsByGeneratedBy data xxxx", res.data);
            
            if (res.data.success) {
                setReportLogsListByGeneratedBy(res.data.data); 
                setFetchingReportLogs(false); 
                setSearchingGeneratedBy(true);  
            }

        }).catch((error) => {
            console.log("listReportLogsByGeneratedBy error xxxx", error);

            setFetchingReportLogs(false);
            setSearchingGeneratedBy(false);
        })
    }

    const listReportLogsByStatus = (startDate, endDate, report_type, status) => {
        setFetchingReportLogs(true);
        setSearchingGeneratedBy(false);
        setReportLogsList([]); 
        setReportLogsListByGeneratedBy([]);

        ReportLogsService.listReportLogsByStatus(startDate, endDate, report_type, status).then((res) => {
            console.log("listReportLogsByStatus data xxxx", res.data);
            
            if (res.data.success) {
                setReportLogsListByStatus(res.data.data); 
                setFetchingReportLogs(false); 
                setFilterByStatus(true);  
            }

        }).catch((error) => {
            console.log("listReportLogsByStatus error xxxx", error);

            setFetchingReportLogs(false);
            setFilterByStatus(false);
        })
    }

    const listReportLogsByGeneratedByAndStatus = (startDate, endDate, report_type, generated_by, status) => {
        setFetchingReportLogs(true);
        setFilterByStatus(false); 
        setSearchingGeneratedBy(false);
        setReportLogsListByGeneratedBy([]);
        setReportLogsListByStatus([]);

        ReportLogsService.listReportLogsByGeneratedByAndStatus(startDate, endDate, report_type, generated_by, status).then((res) => {
            console.log("listReportLogsByGeneratedByAndStatus data xxxx", res.data);
            
            if (res.data.success) {
                setReportLogsList(res.data.data); 
                setFetchingReportLogs(false); 
            }

        }).catch((error) => {
            console.log("listReportLogsByGeneratedByAndStatus error xxxx", error);

            setFetchingReportLogs(false);
        })
    }

    const viewReportLogs = (reportId) => {
        setFetchingLogDetails(true);

        ReportLogsService.viewReportLogs(reportId).then((res) => {
            console.log("viewReportLogs data xxxx", res.data);
            
            if (res.data.success) {
                setReportLogsData(res.data.data); 
                setFetchingLogDetails(false);   
            }

        }).catch((error) => {
            console.log("viewReportLogs error xxxx", error);

            setFetchingLogDetails(false);
        })
    }

    const downloadAsReport = (reportId, reportName, format) => {
        setDownloadingReport(true);
    
        ReportLogsService.downloadReportLogs(reportId).then((res) => {
            console.log("downloadAsReport data", res.data);
    
            if (res.data) {
                let blob = res.data;
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
    
                if (format === "excel") {
                    a.href = url;
                    a.download = `${reportName}.xlsx`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }

                if (format === "csv") {
                    const reader = new FileReader();

                    reader.onload = (e) => {
                        const arrayBuffer = e.target.result;
                        const workbook = XLSX.read(arrayBuffer, {type: "array"});
                        const csvData = XLSX.utils.sheet_to_csv(workbook.Sheets[workbook.SheetNames[0]]);
                        const csvBlob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});

                        saveAs(csvBlob, `${reportName}.csv`);
                    }

                    reader.readAsArrayBuffer(blob);
                }
    

                if (format === "pdf") {
                    const reader = new FileReader();

                    reader.onload = (e) => {
                        const arrayBuffer = e.target.result;
                        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
                        const sheet = workbook.Sheets[workbook.SheetNames[0]];
                        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
    
                        const pdf = new jsPDF();
                        pdf.text(`Report: ${reportName}`, 10, 10);
    
                        autoTable(pdf, {
                            head: [jsonData[0]], 
                            body: jsonData.slice(1),
                        });
    
                        pdf.save(`${reportName}.pdf`);
                    };

                    reader.readAsArrayBuffer(blob);
                }
    
                enqueueSnackbar(`Successfully downloaded ${reportName} as ${format.toUpperCase()}`, {
                    variant: "success",
                    autoHideDuration: 4500
                });
            }
    
            setDownloadingReport(false);

        }).catch((error) => {
            console.error("downloadReportLogs error", error);

            enqueueSnackbar(`Failed to download the report: ${error.message}`, {
                variant: "error"
            });

            setDownloadingReport(false);
        });
    }

    const downloadReportLogs = (reportId, reportName) => {
        setDownloadingReport(true);

        ReportLogsService.downloadReportLogs(reportId).then((res) => {
            console.log("downloadReportLogs data xxxx", res.data);
            
            if (res.data) {
                let blob = res.data;
                
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');

                a.href = url;
                a.download = `${reportName}.xlsx`;
                document.body.appendChild(a);
                a.click();
                a.remove();

                let excelFilename = `${reportName}.xlsx`;
                
                enqueueSnackbar(`Successfully downloaded report, please check your downloads folder for the file: ${excelFilename}`, { 
                    variant: "success",
                    autoHideDuration: 4500
                });
                
                setDownloadingReport(false); 
            }

        }).catch((error) => {
            console.log("downloadReportLogs error xxxx", error);

            setDownloadingReport(false);
        })
    }
   
    return {
        reportLogsList, isFetchingReportLogs, reportLogsListByGeneratedBy, isSearchingGeneratedBy, isFetchingLogDetails, isFilterByStatus, 
        reportLogsListByStatus, reportLogsData, listReportLogs, listReportLogsByGeneratedBy, viewReportLogs, listReportLogsByStatus, 
        isDownloadingReport, listReportLogsByGeneratedByAndStatus, downloadReportLogs, downloadAsReport
    } 
    
}

export default useReportLogs